import { useContext } from "react";
import { TypeAnimation } from "react-type-animation";
import { WebsiteContext } from "./context/AppContext";

const Example = () => {
    const { isMobileView } = useContext(WebsiteContext);
  return (
    <>
     {
      isMobileView ? 
      <TypeAnimation
      sequence={[
        "❤ We produce our service in Coimbatore ❤",
        1000,
        "❤ We produce our service in Chennai ❤",
        1000,
        "❤ We produce our service in Trichy ❤",
        1000,
        "❤ We produce our service in Madurai ❤",
        1000,
        "❤ We produce our service in Salem ❤",
        1000,
        "❤ We produce our service in Karur ❤",
        1000,
        "❤ We produce our service in Ooty ❤",
        1000,
        "❤ We produce our service in Cochin ❤",
        1000,
        "❤ We produce our service in Bangalore ❤",
        1000,
      ]}
      wrapper="span"
      speed={10}
      style={{ fontSize: 30, fontFamily: "Nexa-Bold", color:"#000000" }}
      repeat={Infinity}
    />
    :
    <TypeAnimation
      sequence={[
        "❤ We produce our service in Coimbatore ❤",
        1000,
        "❤ We produce our service in Chennai ❤",
        1000,
        "❤ We produce our service in Trichy ❤",
        1000,
        "❤ We produce our service in Madurai ❤",
        1000,
        "❤ We produce our service in Salem ❤",
        1000,
        "❤ We produce our service in Karur ❤",
        1000,
        "❤ We produce our service in Ooty ❤",
        1000,
        "❤ We produce our service in Cochin ❤",
        1000,
        "❤ We produce our service in Bangalore ❤",
        1000,
      ]}
      wrapper="span"
      speed={10}
      style={{ fontSize: 30, fontFamily: "Nexa-Bold", color:"#000000" }}
      repeat={Infinity}
    />
     }
    </>
    
  );
};

export default Example;
